import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import useFetch from '../../Services/useFetch';
import entities from '../../utils/entities';
import { Button,Row,Col,Container } from 'reactstrap';
import FormInput from '../Form/FormInput';
import Editor from '../Models/Editor';
import ReactImageGallery from 'react-image-gallery';
import AircraftCategorySelector from '../Form/AircraftCategorySelector';
import { useFormikContext } from 'formik';
import { useAlert } from '../../Services/AlertContext';
import useFetchSimple from '../../Services/useFetchSimple';
import LoadingAnimation from '../Form/LoadingAnimation';

const AircraftImages = ({ route, aircraft, newImages, setNewImages,supplierId }) => {
    const [imageList, loading, error, reload] = useFetch(aircraft?.id ? entities.aircraftImages.getByStatus() + aircraft.id : null);
    const [images, setImages] = useState([]);
    const [editImage, setEditImage] = useState();
    const fetch = useFetchSimple();
   
    const myalert = useAlert();
    const [saving, setSaving] = useState();


    useEffect(() => {
        if (imageList) {
            const images = imageList.map(x => ({ original: [x.contentType, x.file].join(",") }))
            setImages(images);
        }
    }, [imageList]);
    useEffect(() => {
        if (newImages) {
            const images = newImages.map(x => ({ original: [x.contentType, x.file].join(",") }))
            setImages(images);
        }
    },[newImages])
    const changeAircraftImages = () => {
        
        setEditImage(entities.aircraftImages.newItem(aircraft));
    }
    const imageEditorClosed = () => setEditImage(false); 
    const saveImage = (values) => {
        const options = { method: 'POST', body: JSON.stringify(values) };
        setSaving(true);
        if (aircraft.id) {
            return fetch(entities.aircraftImages.addSingle, options).then((result) => {
                var ret = result.body;
                if (ret.success) {
                    const m = ret.messages;
                    myalert({
                        title: 'Saved',
                        body: <div>
                            <h5>Saved image.</h5>
                            {m && m.length ? m.map(x => <p>{x}</p>) : null}
                        </div>,
                        onDismiss: () => {
                            setSaving(false);
                            setEditImage();
                        }
                    });
                }
                else {
                    alert({

                        title: 'Saved', body: <div>
                            <h5>Saved image.</h5>
                            {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                        </div>
                        , onDismiss: () => {

                            setSaving(false);

                        }
                    });

                }


            }, (error) => {
                const errors = error?.body?.errors;
                const messages = errors ? Object.keys(errors).map((x, i) => {
                    return <p key={i}>{errors[x].map(y => y)}</p>
                }) : null
                alert({
                    title: 'Error saving image', body: <div>
                        <h3>Unexpected Result</h3>
                        {messages ? messages : JSON.stringify(error)}
                    </div>
                });

                    setSaving(false);
            }).catch((e) => {
                alert({ title: 'Error saving image', body: "Exception Result: " + e ? JSON.stringify(e) : 'No Error!' });
                setSaving(false);

            })
        }
        else {
            setNewImages([...newImages, values]);
            setEditImage();
        }

    };

    return <Container>
        {loading || saving ? <LoadingAnimation /> : null}
        {error && <h5>Error<Button onClick={reload}>Retry</Button></h5>}
        <Editor route={route} entity={entities.aircraftImages} newItem={editImage} editorClosed={imageEditorClosed} onSave={saveImage}/>
        {!loading ? !error && images && images.length ? <ReactImageGallery items={images ? images : []} /> : <div style={{ justifyContent: 'center', width: '100%', display: 'flex' }}><Row><h1>No Aircraft Images</h1></Row><h1 style={{ fontSize: "80px" }}><span role="img" aria-label="disappointed">😞</span></h1></div> : null}
        <Button onClick={changeAircraftImages}>Set/Change Images</Button>
        </Container>
}
const AircraftDetail = ({ route }) => {
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const [newImages, setNew] = useState([]); 
    
    const { values,setFieldValue } = useFormikContext();
    const setNewImages = (images) => {

        setFieldValue('images', images.map(x => {
           
            return { ...values, ...x };
        }));
        setNew(images);
    }
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <AircraftCategorySelector id='aircraftCategory' label='Category' />
                        </Col>
                        <Col>
                            <FormInput id='licenseNumber' label='Registration Number' />
                        </Col>
                        <Col>
                            <FormInput id='type' label='Make and Model' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='passengerLimit' label='Passenger Limit' type='numeric' />
                        </Col>
                     
                        
                    </Row>
             
                </Col>
                <Col>
                    <Row>
                        <AircraftImages  newImages={newImages} setNewImages={setNewImages} route={route} supplierId={values.supplierId} aircraft={values} />

                    </Row>
                </Col>
            </Row>
            <Row>
                <Col>
                <FormInput id='aircraftNotes' label='Notes' type='textarea' />
            </Col>
            </Row>
        </Container>
    </React.Fragment>
};

export default AircraftDetail;




